module.exports = __webpack_public_path__ + "static/media/first-view-mockup.76bfa5a1.png";